
export const accessToken = 'pk.eyJ1Ijoiam91cm5leXdvcmtzIiwiYSI6ImNrZmd5MzZpdjBmbGcyeHMyMmMyam13dXEifQ.0AId_8jEbAe2NLbD8WfJvw'

export const mapStyle = 'mapbox://styles/journeyworks/ckfh3ps192s9s19p8adghcgra'

export const mapConfig = {
  zoom: 12.38,
  center: [4.590080, 51.932839]
}

export const planMode = true

export const layers = {
  hexagons: {
    url: 'mapbox://journeyworks.gent_resultaat_per_hexagon',
    source: "gent_resultaat_per_hexagon",
    active: true
  },
  hexagonCenterpoints: {
    url: "mapbox://",
    source: "",
    active: false
  },
  parking: {
    url: "mapbox://journeyworks.gent_parkeerstroken",
    source: "gent_parkeerstroken",
    active: true
  },
  trees: {
    url: "mapbox://journeyworks.4ywmpir5",
    source: "gent_straatbomen-3f9j6j",
    active: true
  },
  chargingpoints: {
    url: "mapbox://journeyworks.9931i81n",
    source: "gent_laadpunten-33v54v",
    active: true
  },
  plannedchargingpoints: {
    active: planMode
  },
  fuelstations: {
    url: "mapbox://",
    source: "",
    active: false
  },
  border: {
    url: "mapbox://journeyworks.dqq19ysc",
    source: "gent_gemeentegrens-3tjkup",
    active: true
  },
  visitorlocations: {
    url: "mapbox://journeyworks.gent_bezoekers_hexid",
    source: "gent_bezoekers_hexid",
    active: true
  },
  pplusr: {
    url: "mapbox://journeyworks.8yil08rf",
    source: "gent_p_en_r-2uea5h",
    active: true
  },
  ls: {
    url: "mapbox://journeyworks.gent_laagspanning",
    source: "gent_laagspanning",
    active: true
  },
  ovkasten: {
    url: "mapbox://",
    source: "",
    active: false
  },
  grondeigendom: {
    url: "mapbox://",
    source: "",
    active: false
  },
  parkingintensity: {
    url: "mapbox://",
    source: "",
    active: false
  }
}

